import * as ActionTypes from './actionTypes';

const initialState = {
  invoices: null,
  invoicesLoading: true,
  globalInvoices: null,
  globalInvoicesLoading: true,
  globalInvoiceDetail: null,
  globalInvoiceDetailLoading: true,
  invoiceDetail: null,
  invoiceDetailLoading: true,
  payLoading: false,
  exportInvoiceLoading: false,
};

export default function invoice(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.GET_INVOICES:
      return {
        ...state,
        invoicesLoading: true,
      };

    case ActionTypes.GET_INVOICES_SUCCESS:
      return {
        ...state,
        invoicesLoading: false,
        invoices: action.payload,
      };

    case ActionTypes.GET_INVOICES_FAILED:
      return {
        ...state,
        invoicesLoading: false,
      };

    case ActionTypes.GET_GLOBAL_INVOICES:
      return {
        ...state,
        globalInvoicesLoading: true,
      };

    case ActionTypes.GET_GLOBAL_INVOICES_SUCCESS:
      return {
        ...state,
        globalInvoicesLoading: false,
        globalInvoices: action.payload,
      };

    case ActionTypes.GET_GLOBAL_INVOICES_FAILED:
      return {
        ...state,
        globalInvoicesLoading: false,
      };

    case ActionTypes.GET_GLOBAL_INVOICE_DETAIL:
      return {
        ...state,
        globalInvoiceDetailLoading: true,
      };

    case ActionTypes.GET_GLOBAL_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        globalInvoiceDetailLoading: false,
        globalInvoiceDetail: action.payload,
      };

    case ActionTypes.GET_GLOBAL_INVOICE_DETAIL_FAILED:
      return {
        ...state,
        globalInvoiceDetailLoading: false,
      };

    case ActionTypes.CLEANUP_GLOBAL_INVOICE_DETAIL:
      return {
        ...state,
        globalInvoiceDetail: null,
        globalInvoiceDetailLoading: true,
      };

    case ActionTypes.GET_INVOICE_DETAIL:
      return {
        ...state,
        invoiceDetailLoading: true,
      };

    case ActionTypes.GET_INVOICE_DETAIL_SUCCESS:
      return {
        ...state,
        invoiceDetailLoading: false,
        invoiceDetail: action.payload,
      };

    case ActionTypes.GET_INVOICE_DETAIL_FAILED:
      return {
        ...state,
        invoiceDetailLoading: false,
      };

    case ActionTypes.PAY_INVOICE:
      return {
        ...state,
        payLoading: true,
      };

    case ActionTypes.PAY_INVOICE_SUCCESS:
    case ActionTypes.PAY_INVOICE_FAILED:
      return {
        ...state,
        payLoading: false,
      };

    case ActionTypes.EXPORT_INVOICE:
      return {
        ...state,
        exportInvoiceLoading: true,
      };

    case ActionTypes.EXPORT_INVOICE_SUCCESS:
    case ActionTypes.EXPORT_INVOICE_FAILED:
      return {
        ...state,
        exportInvoiceLoading: false,
      };

    default:
      return state;
  }
}
